import React from 'react';
import NavbarInfoProduct from '../pages/components/NavbarInfoProduct';
import AddKategori from '../pages/AddKategori';

export default function LayoutAddKategori() {
  return (
    <>
      <NavbarInfoProduct />
      <AddKategori />
    </>
  );
}
